import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators, FormArray} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {User} from '../../services/user/user';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {Carrier} from 'src/app/services/carrier/carrier';
import {AlertService} from '../../services/alert/alert.service';
import {HhgOnlineBookShipmentService} from './hhg-online-book-shipment.service';
import {CarrierLocalAgentService} from '../../services/carrier-local-agent/carrier-local-agent.service';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {reqPackagingDateValidator} from './validators';
import {UserProfileService} from 'src/app/services/user-profile/user-profile.service';
import {BookShipmentRequest} from './book-shipment';
import AppConstants, {NameAndAddressRecordType, BookShipmentStatus} from 'src/app/shared/common-components/AppConstants';
import {BehaviorSubject} from 'rxjs';
import {takeWhile} from 'rxjs';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {NameAndAddressService} from '../../services/name-and-address/name-and-address.service';
import {BillofladingAddressesComponent} from '../billoflading-addresses/billoflading-addresses.component';
import {CarrierService} from '../../services/carrier/carrier.service';
import {HhgBookShipAccessorialsService} from '../../services/hhg-book-ship-accessorials/hhg-book-ship-accessorials.service';
import _ from 'lodash';

@Component({
    selector: 'app-hhg-online-book-shipment',
    templateUrl: './hhg-online-book-shipment.component.html',
    styleUrls: ['./hhg-online-book-shipment.component.css'],
    standalone: false
})
export class HhgOnlineBookShipmentComponent implements OnInit, OnDestroy {

  private observer$ = new BehaviorSubject(true);
  isExtendedStorage = false;
  hhgOnlineBookShipmentForm: FormGroup;
  initFormData: any;
  finalFormData: any;
  carrier: Carrier;
  public modalRef: BsModalRef;
  isCarrierView = false; // use this field and set it to true if its carrier view
  validationMessages = {
    'employeeFirstName': [
      {type: 'required', message: 'First name is required'}
    ],
    'employeeLastName': [
      {type: 'required', message: 'Last name is required'}
    ],
    'moveDate': [
      {type: 'required', message: 'Pickup/Move Date is required'}
    ],
    'shipmentType': [
      {type: 'required', message: 'Booking elements is required'}
    ]
  };

  bookingTypesRef: any[] = [
    {name: 'HHG', value: 'HHG'},
    {name: 'UAB', value: 'HHG-UAB'},
    {name: 'POV', value: 'HHG-POV'}
  ];

  optionalTypes: string[] = ['Yes', 'No'];

  // TODO: Verify options with Chandu
  surveyReqTypes: string[] = ['After Acceptance', 'Before Acceptance', 'No'];

  // TODO: Verify options with Chandu
  surveyTypes: string[] = ['Onsite', 'By Phone', 'Virtual', 'None'];

  numberOfDays: number[];
  numberOfHours: number[];
  selectedBookingTypes: [string];

  shipmentDetailsData: any = {};
  shipperInfo: User | any;
  shipmentCostInfo: any = {};
  shipmentLabelInfo: any = {};
  shipmentInfo: any = {};
  bookShipmentInfo: any = {};
  ratesHhgInfo: any = {};
  rateTypesInfo: any = {};
  ratesSroInfo: any = {};
  requestedLocalAgentInfo: any = {};
  assignedLocalAgentInfo: any = {};
  carrierOrganizationInfo: any = {};
  originAddress = '';
  destinationAddress = '';
  originCountry = '';
  destinationCountry = '';
  shipmentType: any;
  cancelBookShipment = false;
  disabled = false;

  prefLocalAgentData: any = [];
  prefLocalAgentList: any = [];
  minDate: Date;
  agencyInfo: any;
  currentShipmentInfo: any;
  shipmentBookingStatus = '';
  isAcceptedWithQualificationByCarrier = false;
  acceptRejectionWithReason = false;
  acceptSpecifyReason = false;
  rejectSpecifyReason = false;
  surfacePercentage = 0;
  agencyUser = false;
  disabledConfirm = true;

  bookshipmentid: any;
  selectedShipmentType: any;

  addressValidationRecordTypes: any = [
    'Origin', 'Destination', 'Bill To', 'Shipper', 'Consignee', 'Issue Office'
  ];

  carrierAcceptRefuseOptions: any = [
    'Accept',
    'Accept With Qualification',
    'Refuse',
  ];

  carrierAcceptOptions: any = [
    'Alternate Pickup Date',
    'Alternate Delivery Date',
    'Equipment Availability',
    'Pre-Move Survey Required',
    'New Accessorial Requested',
    'Accessorial Qualified',
    'Other',
  ];
  accessorialTspStatus = [];

  carrierRejectOptions: any = [
    'Equipment Not Available',
    'Staff Not Available',
    'Not Cost Efficient',
    'Shipment Pickup in an area that the TSP cannot service',
    'Shipment Delivery in an area that the TSP cannot service',
    'Weather',
    'Time Frame/Too Busy',
    'Other',
  ];

  constructor(private formBuilder: FormBuilder, private loader: LoadingService, private router: Router,
              private route: ActivatedRoute, private userService: UserService, private carrierService: CarrierService,
              private onlineBookShipmentService: HhgOnlineBookShipmentService,
              private carrierLocalAgentService: CarrierLocalAgentService, private nameAndAddressService: NameAndAddressService,
              private alertService: AlertService, private userProfileService: UserProfileService, private hhgBookShipAccessorialsService: HhgBookShipAccessorialsService,
              private modalService: BsModalService) {
  }

  ngOnInit() {
    console.log('hhg online book shipment initilizing');
    const bookshipmentid = this.route.snapshot.queryParamMap.get('bookshipmentid');
    this.bookshipmentid = bookshipmentid;
    this.createHHGOnlineBookShipmentForm();
    this.onlineBookShipmentService.getShipmentsObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      this.currentShipmentInfo = data;
    }, (error) => {
      this.loader.hide();
    });

    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value)).subscribe((currentUser: any) => {
      this.loadCarrierView(currentUser);
      this.agencyUser = Boolean(currentUser.agencyUser);
      console.log(currentUser);
    }, (error) => {
      this.loader.hide();
      console.log(error);
    });

    if (!AppConstants.isNotNullCondition(this.currentShipmentInfo)) {
      // Retrieve shipment data from database
      this.getShipmentInfoByBookShipmentId(bookshipmentid);
    } else {

      this.shipmentDetailsData = this.currentShipmentInfo;
      this.getAccessorialsList(this.shipmentDetailsData.shipmentsInfoId);
      this.loadInitialData();
      this.onlineBookShipmentService.setShipmentsObservable(null);
    }
    this.minDate = new Date();

    window.scrollTo(0, 0);
  }

  getAccessorialsList(shipmentsInfoId) {
    this.hhgBookShipAccessorialsService.getAccessorialsByShipmentId(shipmentsInfoId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe((data: any) => {
      if (AppConstants.isNotNullCondition(data)) {
        data.forEach(accessorial => {
          this.accessorialTspStatus.push(accessorial.tspRequest);
        });
      }
    }, error => {
      this.loader.hide();
      this.alertService.error('Error retrieving accessorials');
    });
  }

  loadCarrierView(currentUser) {
    if (AppConstants.isNotNullCondition(currentUser)) {
      const carrierRoles = AppConstants.getCarrierRolesArray();
      if (currentUser.roles.some(role => carrierRoles.indexOf(role.name) >= 0)) {
        this.isCarrierView = true;
      }
    }
  }

  createHHGOnlineBookShipmentForm() {
    this.hhgOnlineBookShipmentForm = this.formBuilder.group({
      shipmentType: this.createBookingTypesControls(),
      employeeFirstName: new FormControl('', Validators.required),
      employeeMiddleInitial: new FormControl(''),
      employeeLastName: new FormControl('', Validators.required),
      employeeEmail: new FormControl('', [Validators.pattern('^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,6})$')]),
      employeePhone: new FormControl('', [Validators.minLength(10), Validators.maxLength(15), CommonValidators.numeric]),
      employeeUniqueIdentifier: new FormControl('', [Validators.maxLength(25)]),
      originatorFirstName: new FormControl(''),
      originatorMiddleInitial: new FormControl(''),
      originatorLastName: new FormControl(''),
      requestedPackingDate: new FormControl(''),
      moveDate: new FormControl('', Validators.required),
      requiredDeliveryDate: new FormControl(''),
      professionalBooksEquipments: new FormControl(''),
      preMoveSurveyType: new FormControl(''),
      preMoveSurveyReqd: new FormControl(''),
      tspResponseInDays: new FormControl(''),
      tspResponseInHours: new FormControl(''),
      bookingType: new FormControl(''),
      additionalComments: new FormControl(''),
      tspAdditionalComments: new FormControl(''),
      localAgentSelected: new FormControl(''),
      prefLocalAgent: new FormControl(''),
      carrierAcceptRefuseStatus: new FormControl(''),
      carrierAcceptOption: new FormControl(''),
      carrierRefuseOption: new FormControl(''),
      carrierAcceptReason: new FormControl(''),
      carrierRefuseReason: new FormControl('')
    });
  }

  /**
   * @description To get shipment details by book shipment id
   * @param docRefNumber: Book shipment id of the shipment
   */
  getShipmentInfoByBookShipmentId(bookshipmentid) {
    this.loader.show();
    this.onlineBookShipmentService.getShipmentInfoByBookShipmentId(bookshipmentid).pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      this.shipmentDetailsData = data;
      this.getAccessorialsList(this.shipmentDetailsData.shipmentsInfoId);
      this.loadInitialData();
      this.loader.hide();
      // this.alertService.success('Successfully retrieved Shipment details');
    }, error => {
      this.loader.hide();
      this.alertService.error('Error retrieving shipment details');
    }, () => {
      this.loader.hide();
    });
  }

  /**
   * @description Prepopulates selected data from the previous page
   */
  loadInitialData() {
    this.numberOfDays = Array(10).fill(0).map((x, i) => i + 1);
    this.numberOfHours = Array(9).fill(1).map((x, i) => i + 2);
    const form = this.hhgOnlineBookShipmentForm;
    this.shipmentInfo = this.shipmentDetailsData;
    this.bookShipmentInfo = this.shipmentInfo.bookShipmentsEntity;
    this.ratesSroInfo = this.shipmentInfo.ratesSroMasterEntity;
    this.shipmentCostInfo = this.shipmentInfo.hhgShipmentsCostInfoEntity;
    this.ratesHhgInfo = this.shipmentCostInfo ? this.shipmentCostInfo.ratesHhgEntity : this.ratesHhgInfo;
    this.rateTypesInfo = this.ratesHhgInfo ? this.ratesHhgInfo.rateTypesEntity : this.rateTypesInfo;
    if (AppConstants.isNotNullCondition(this.ratesHhgInfo.rateTypesEntity)) {
      this.isExtendedStorage = this.ratesHhgInfo.rateTypesEntity.transportationType.toUpperCase() === 'EXTENDED STORAGE' ? true : false;
    }
    this.shipperInfo = this.bookShipmentInfo.userEntity;
    this.loadCarrierDetails(this.shipmentCostInfo.carrierId);
    const organizationEntity = this.bookShipmentInfo.organizationEntity;
    if (AppConstants.isNotNullCondition(organizationEntity) && AppConstants.isNotNullCondition(organizationEntity.agencyCustomerEntity)) {
      this.agencyInfo = organizationEntity.agencyCustomerEntity.agencyMasterEntity;
    }
    const addressInfo = this.shipmentInfo.nameAndAddressEntity;
    addressInfo.forEach(addressObj => {
      const country = addressObj.countryEntity.stateCountryName;
      const city = AppConstants.isNotNullCondition(addressObj.city) ? (addressObj.city + ',') : '';
      const state = AppConstants.isNotNullCondition(addressObj.stateEntity) ? addressObj.stateEntity.stateCountryCode2Digit : '';
      const zip = AppConstants.isNotNullCondition(addressObj.zipCode) ? ('(' + addressObj.zipCode + ')') : '';

      // const cityStateZip = addressObj.city + ',' + addressObj.stateEntity.stateCountryCode2Digit + '(' + addressObj.zipCode + ')';
      if (addressObj.recordType === NameAndAddressRecordType.ORIGIN) {
        this.originAddress = city + state + zip;
        this.originCountry = country;
      } else if (addressObj.recordType === NameAndAddressRecordType.DESTINATION) {
        this.destinationAddress = city + state + zip;
        this.destinationCountry = country;
      }
    });

    if (AppConstants.isNotNullCondition(this.ratesHhgInfo)) {
      if (this.originCountry === 'UNITED STATES' || this.destinationCountry === 'UNITED STATES') {
        this.surfacePercentage = 100 - this.ratesHhgInfo.linehaul;
      } else {
        this.surfacePercentage = this.ratesHhgInfo.linehaul;
      }
    }

    // Pre-populate form data
    form.controls['moveDate'].setValue(this.shipmentInfo.moveDate != null ? new Date(this.shipmentInfo.moveDate) : this.shipmentInfo.moveDate);
    form.controls['requestedPackingDate'].setValue(this.shipmentInfo.requestedPackingDate != null ? new Date(this.shipmentInfo.requestedPackingDate) : this.shipmentInfo.requestedPackingDate);
    form.controls['requiredDeliveryDate'].setValue(this.shipmentInfo.requiredDeliveryDate != null ? new Date(this.shipmentInfo.requiredDeliveryDate) : this.shipmentInfo.requiredDeliveryDate);
    form.controls['professionalBooksEquipments'].setValue(this.shipmentInfo.professionalBooksEquipments === 1 ? 'Yes' : 'No');
    form.controls['preMoveSurveyType'].setValue(this.bookShipmentInfo.preMoveSurveyType);
    form.controls['preMoveSurveyReqd'].setValue(this.bookShipmentInfo.preMoveSurveyReqd);
    form.controls['tspResponseInDays'].setValue(this.bookShipmentInfo.tspResponseInDays);
    form.controls['tspResponseInHours'].setValue(this.bookShipmentInfo.tspResponseInHours);
    form.controls['additionalComments'].setValue(this.bookShipmentInfo.additionalComments);
    form.controls['tspAdditionalComments'].setValue(this.bookShipmentInfo.tspAdditionalComments);
    form.controls['employeeUniqueIdentifier'].setValue(this.bookShipmentInfo.employeeUniqueIdentifier);
    form.controls['bookingType'].setValue(this.bookShipmentInfo.bookingType === 'Offline' ? true : false);
    form.controls['localAgentSelected'].setValue(this.bookShipmentInfo.localAgentSelected === 1 ? 'Yes' : 'No');

    if (this.bookShipmentInfo.localAgentSelected === 1) {

      this.onLocalAgentRequiredSelecion('Yes');
    }
    form.controls['prefLocalAgent'].setValue(this.bookShipmentInfo.requestedLocalAgentId ?
      this.bookShipmentInfo.requestedLocalAgentId.toString() : '');

    this.requestedLocalAgentInfo = this.bookShipmentInfo.requestedLocalAgentsEntity;
    this.assignedLocalAgentInfo = this.bookShipmentInfo.assignedLocalAgentsEntity;

    // pre-populate Shipment/Booking Types if any
    if (this.bookShipmentInfo.shipmentType) {
      const shipmentTypeArray = this.bookShipmentInfo.shipmentType.split(' & ');
      const bookingTypesArray = <FormArray>form.controls.shipmentType;
      if (shipmentTypeArray && bookingTypesArray) {
        bookingTypesArray.controls.forEach((bookingType, i) => {
          bookingType.setValue(shipmentTypeArray.find(sTypeVal =>
            sTypeVal.toUpperCase() == this.bookingTypesRef[i].value.toUpperCase() ? true : false));
          if (!bookingType.value) {
            bookingType.disable();
          }
          if (this.isCarrierView) {
            bookingType.disable();
          }
        });
      }
    }

    this.shipmentLabelInfo = this.shipmentInfo.shipmentsLabelInfoEntity;
    if (this.shipmentLabelInfo) {
      form.controls['employeeFirstName'].setValue(this.shipmentLabelInfo.employeeFirstName);
      form.controls['employeeMiddleInitial'].setValue(this.shipmentLabelInfo.employeeMiddleInitial);
      form.controls['employeeLastName'].setValue(this.shipmentLabelInfo.employeeLastName);
      form.controls['employeePhone'].setValue(this.shipmentLabelInfo.employeePhone);
      form.controls['employeeEmail'].setValue(this.shipmentLabelInfo.employeeEmail);
      form.controls['originatorFirstName'].setValue(this.shipmentLabelInfo.originatorFirstName);
      form.controls['originatorMiddleInitial'].setValue(this.shipmentLabelInfo.originatorMiddleInitial);
      form.controls['originatorLastName'].setValue(this.shipmentLabelInfo.originatorLastName);
    }

    if (this.bookShipmentInfo.bookingStatus === BookShipmentStatus.CANCELLED ||
      this.bookShipmentInfo.bookingStatus === BookShipmentStatus.REFUSED) {
      this.disabled = true;
    }

    // if (this.isCarrierView) {
    if (this.bookShipmentInfo.bookingStatus === BookShipmentStatus.ACCEPTED_WITH_QUALIFICATION) {
      form.controls['carrierAcceptRefuseStatus'].setValue('Accept With Qualification');
      form.controls['carrierAcceptOption'].setValue(this.bookShipmentInfo.refusalOrQualificationReason);
      form.controls['carrierAcceptReason'].setValue(this.bookShipmentInfo.refusalOrQualificationRemarks);
      this.acceptRejectionWithReason = true;
      this.isAcceptedWithQualificationByCarrier = true;
      // if (this.bookShipmentInfo.refusalOrQualificationReason === 'Other') {
      this.acceptSpecifyReason = true;
      // }

    } else if (this.bookShipmentInfo.bookingStatus === BookShipmentStatus.REFUSED) {
      form.controls['carrierAcceptRefuseStatus'].setValue('Refuse');
      form.controls['carrierRefuseOption'].setValue(this.bookShipmentInfo.refusalOrQualificationReason);
      form.controls['carrierRefuseReason'].setValue(this.bookShipmentInfo.refusalOrQualificationRemarks);
      this.acceptRejectionWithReason = true;
      this.isAcceptedWithQualificationByCarrier = false;
      // if (this.bookShipmentInfo.refusalOrQualificationReason === 'Other') {
      this.rejectSpecifyReason = true;
      // }
    } else {
      form.controls['carrierAcceptRefuseStatus'].setValue('Accept');
    }

    if (this.isCarrierView && this.bookShipmentInfo.bookingType === 'Online' &&
      this.bookShipmentInfo.bookingStatus === BookShipmentStatus.PENDING &&
      AppConstants.isNotNullCondition(this.bookShipmentInfo.confirmationDate)) {
      const confirmDate = new Date(this.bookShipmentInfo.confirmationDate);
      if (AppConstants.isNotNullCondition(this.bookShipmentInfo.tspResponseInDays)) {
        confirmDate.setDate(confirmDate.getDate() + this.bookShipmentInfo.tspResponseInDays);
      } else if (AppConstants.isNotNullCondition(this.bookShipmentInfo.tspResponseInHours)) {
        confirmDate.setHours(confirmDate.getHours() + this.bookShipmentInfo.tspResponseInHours);
      }
      if (confirmDate < new Date()) {
        this.alertService.warn('Shipment Request has been expired as you did not respond on time');
        this.bookShipmentInfo.bookingStatus = BookShipmentStatus.EXPIRED;
        this.disabled = true;
        this.saveShipment(null);
      }
    }
    
   this.initValueForBookedStatus();
  }

  /**
   * @description To get carrier details
   * @param carrierId
   */
  loadCarrierDetails(carrierId) {
    if (carrierId) {
      this.loader.show();
      this.carrierService.getCarrierByCarrierId(carrierId).subscribe(data => {
        if (AppConstants.isNotNullCondition(data)) {
          this.carrier = data;
          if (this.carrier.carrierContactInfoEntity.length !== 0) {
            for (let i = 0; i < this.carrier.carrierContactInfoEntity.length; i++) {
              if (this.carrier.carrierContactInfoEntity[i].contactType === 'HHG') {
                this.carrierOrganizationInfo = this.carrier.carrierContactInfoEntity[i];
                break;
              } else {
                this.carrierOrganizationInfo = this.carrier.organizationEntity;
              }
            }
          } else {
            this.carrierOrganizationInfo = this.carrier.organizationEntity;
          }
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        console.log('There was an error retrieving TSP details =>' + error);
        this.alertService.error('Error retrieving TSP details');
      });
    }
  }

  /**
   * @description To get agency/bureau details
   * @param userId
   */
  // loadAgencyDetails(userId) {
  //   if (userId) {
  //     this.loader.show();
  //     this.userProfileService.getUser(userId).subscribe(user => {
  //       if (AppConstants.isNotNullCondition(user) && AppConstants.isNotNullCondition(user.organizationEntity)
  //       && AppConstants.isNotNullCondition(user.organizationEntity.agencyCustomerEntity)) {
  //         this.agencyInfo = user.organizationEntity.agencyCustomerEntity.agencyMasterEntity;
  //       }
  //       this.loader.hide();
  //     }, error => {
  //       this.loader.hide();
  //       console.log('There was an error retrieving agency details =>' + error);
  //       this.alertService.error('Error retrieving agency details');
  //     });
  //   }
  // }

  /**
   * @description To create booking type controls with referennce data and default section
   */
  createBookingTypesControls() {
    const btArray = this.bookingTypesRef.map(bType => {
      return new FormControl(false);
    });
    return new FormArray(btArray);
  }

  /**
   * @description To get local agents from carrierId
   * @param carrierId: carrierId of the carrier
   */
  getCarrierLocalAgentsByCarrierId(carrierId) {
    this.carrierLocalAgentService.getCarrierLocalAgentsByCarrierId(carrierId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      this.prefLocalAgentData = data;
      this.prefLocalAgentList = this.prefLocalAgentData;
    }, error => {
      console.log('There was an error retrieving local agents' + error);
      this.alertService.error('Error retrieving TSP local agents');
    });
  }

  /**
   * @description To get local agent information provided agent id
   * @param agentId: agent id
   */
  getCarrierLocalAgentDetailByAgentId(agentId) {
    this.carrierLocalAgentService.getCarrierLocalAgentByAgentId(agentId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      this.requestedLocalAgentInfo = data;
    }, error => {
      console.log('There was an error retrieving local agents' + error);
      this.alertService.error('Error retrieving local agents');
    });
  }

  /**
   * @description To retrieve selected local agent detail given scac code
   * @param eventObj
   */
  onPreferredAgentSelecion(eventObj) {
    if (eventObj.target.value) {
      this.getCarrierLocalAgentDetailByAgentId(eventObj.target.value);
    }
  }

  /**
   * @description To show all the preferred local agents of the carrier
   * @param selectedEvent
   */
  onLocalAgentRequiredSelecion(selectedEvent) {
    if (selectedEvent === 'Yes') {
      if (this.prefLocalAgentData.length === 0 && AppConstants.isNotNullCondition(this.carrier)) {
        // Populate preferred local agents dropdown
        this.getCarrierLocalAgentsByCarrierId(this.carrier.carrierId);
      }
      this.prefLocalAgentList = this.prefLocalAgentData;

    } else {
      this.prefLocalAgentList = [];
      this.requestedLocalAgentInfo = {};
      this.hhgOnlineBookShipmentForm.controls['prefLocalAgent'].setValue('');
    }
  }

  /**
   * @description saves shipment details
   */
  saveShipment(btnCtrl) {
    if (this.cancelBookShipment) {
      this.shipmentInfo.bookShipmentsEntity.bookingStatus = BookShipmentStatus.CANCELLED;
      this.hhgBookShipmentSave(btnCtrl);
    }
    if (!this.isCarrierView && !this.hhgOnlineBookShipmentForm.valid) {
      this.validateAllFormFields(this.hhgOnlineBookShipmentForm);
    } else if (!this.cancelBookShipment) {
      this.prepareShipmentData(btnCtrl);
      this.hhgBookShipmentSave(btnCtrl);
    }
  }

  /**
   * @description prepares data to save shipment details
   */
  prepareShipmentData(btnCtrl) {
    const formValues = this.hhgOnlineBookShipmentForm.value;
    const bse = this.shipmentInfo.bookShipmentsEntity;
    if (!this.isCarrierView) {
      this.shipmentInfo.moveDate = formValues.moveDate != null ? new Date(formValues.moveDate).toISOString() : null;
      this.shipmentInfo.requestedPackingDate = formValues.requestedPackingDate != null ? new Date(formValues.requestedPackingDate).toISOString() : null;
      this.shipmentInfo.requiredDeliveryDate = formValues.requiredDeliveryDate != null ? new Date(formValues.requiredDeliveryDate).toISOString() : null;
      this.shipmentInfo.professionalBooksEquipments = formValues.professionalBooksEquipments === 'Yes' ? 1 : 0;

      bse.preMoveSurveyType = formValues.preMoveSurveyType;
      bse.preMoveSurveyReqd = formValues.preMoveSurveyReqd;
      bse.tspResponseInDays = formValues.tspResponseInDays;
      bse.tspResponseInHours = formValues.tspResponseInHours;
      bse.bookingType = formValues.bookingType === true ? 'Offline' : 'Online';
      bse.shipmentType = this.getSelectedBookingTypes().join(' & ');
      bse.requestedLocalAgentId = formValues.prefLocalAgent;
      bse.localAgentSelected = formValues.localAgentSelected === 'Yes' ? 1 : 0;
      bse.bookingStatus = AppConstants.isNotNullCondition(this.shipmentBookingStatus) ? this.shipmentBookingStatus :
        this.shipmentInfo.bookShipmentsEntity.bookingStatus;
      bse.additionalComments = formValues.additionalComments;
    }

    if (this.isCarrierView) {
      bse.tspAdditionalComments = formValues.tspAdditionalComments;
      bse.employeeUniqueIdentifier = formValues.employeeUniqueIdentifier;
      if (formValues.carrierAcceptRefuseStatus && btnCtrl === 'confirm') {
        if (this.acceptRejectionWithReason && this.isAcceptedWithQualificationByCarrier) {
          bse.bookingStatus = BookShipmentStatus.ACCEPTED_WITH_QUALIFICATION;
          bse.acceptDate = new Date();
          bse.refusalOrQualificationReason = formValues.carrierAcceptOption;
          bse.refusalOrQualificationRemarks = formValues.carrierAcceptReason;
        } else if (this.acceptRejectionWithReason && !this.isAcceptedWithQualificationByCarrier) {
          bse.bookingStatus = BookShipmentStatus.REFUSED;
          bse.refusalDate = new Date();
          bse.refusalOrQualificationReason = formValues.carrierRefuseOption;
          bse.refusalOrQualificationRemarks = formValues.carrierRefuseReason;
        } else if (formValues.carrierAcceptRefuseStatus === 'Accept') {
          bse.bookingStatus = BookShipmentStatus.ACCEPTED;
          bse.acceptDate = new Date();
        }
      }
    }
    this.shipmentInfo.bookShipmentsEntity = bse;

    const labelInfo = this.shipmentInfo.shipmentsLabelInfoEntity;
    labelInfo.employeeFirstName = formValues.employeeFirstName;
    labelInfo.employeeMiddleInitial = formValues.employeeMiddleInitial;
    labelInfo.employeeLastName = formValues.employeeLastName;
    labelInfo.employeePhone = formValues.employeePhone;
    labelInfo.employeeEmail = formValues.employeeEmail;
    labelInfo.originatorFirstName = formValues.originatorFirstName;
    labelInfo.originatorMiddleInitial = formValues.originatorMiddleInitial;
    labelInfo.originatorLastName = formValues.originatorLastName;
    labelInfo.updateDate = new Date();
    labelInfo.updateProgram = 'hhg-book-shipment';
    this.shipmentInfo.shipmentsLabelInfoEntity = labelInfo;

  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  /**
   * @description Saves shipment details
   */
  hhgBookShipmentSave(btnCtrl) {
    const shipmentReq = new BookShipmentRequest();
    shipmentReq.shipmentInfo = this.shipmentInfo;
    shipmentReq.control = btnCtrl;
    if (shipmentReq.shipmentInfo.bookShipmentsEntity.bookingStatus === 'Cancelled' ) {
      shipmentReq.control = BookShipmentStatus.CANCELLED ;
    }
    this.loader.show();
    this.onlineBookShipmentService.saveShipment(shipmentReq)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(result => {
    }, (error) => {
      console.log('Error saving shipment details' + error);
      this.loader.hide();
    }, () => {
      this.loader.hide();
      if (this.bookShipmentInfo.bookingStatus != BookShipmentStatus.EXPIRED) {
        this.alertService.success('Successfully saved shipment details');
        this.router.navigate(['/', 'shipmentcontrolreview'], {
          queryParams: {
            bookshipmentid: this.shipmentInfo.bookShipmentsEntity.bookShipmentId
          }
        });
      }
    });
  }

  /**
   * @description Gets user selected booking types
   */
  getSelectedBookingTypes() {
    this.selectedBookingTypes = this.hhgOnlineBookShipmentForm.value.shipmentType
      .map((bookingType, i) => {
        console.log(bookingType);
        // Value of checkbox return either true or false. If it is true, it returns value of Booking Types
        // from bookingElementTypes array.
        return bookingType ? bookingType : null;
      })
      .filter((v, i) => {
        return v != null;
      });
    console.log('selectedBookingTypes=', this.selectedBookingTypes);

    return this.selectedBookingTypes;
  }

  /**
   * @description On change booking type event
   */
  changeBookingType(eventObj) {
    if (eventObj.target.checked) {
      this.hhgOnlineBookShipmentForm.controls['tspResponseInDays'].setValue(null);
      this.hhgOnlineBookShipmentForm.controls['tspResponseInHours'].setValue(null);
    } else {
      this.hhgOnlineBookShipmentForm.controls['tspResponseInHours'].setValue(2);
    }
  }

  /**
   * @description On change TSP Response event
   */
  changeTspResponse(eventObj) {
    if (eventObj.target.value && eventObj.target.id === 'tspResponseInDays') {
      this.hhgOnlineBookShipmentForm.controls['bookingType'].setValue(false);
      this.hhgOnlineBookShipmentForm.controls['tspResponseInHours'].setValue(null);
    }
    if (eventObj.target.value && eventObj.target.id === 'tspResponseInHours') {
      this.hhgOnlineBookShipmentForm.controls['bookingType'].setValue(false);
      this.hhgOnlineBookShipmentForm.controls['tspResponseInDays'].setValue(null);
    }
  }

  /**
   * @description Dates Validation
   */
  bsValueChange(eventObj, frmCtrl) {
    if (frmCtrl === 'requestedPackingDate') {
      this.hhgOnlineBookShipmentForm.get(frmCtrl).setValidators([reqPackagingDateValidator(frmCtrl,
        this.hhgOnlineBookShipmentForm.get('moveDate').value, eventObj, this.hhgOnlineBookShipmentForm.get('requiredDeliveryDate').value)]);
      if (this.hhgOnlineBookShipmentForm.get('requiredDeliveryDate').value > this.hhgOnlineBookShipmentForm.get('moveDate').value) {
        this.hhgOnlineBookShipmentForm.get('moveDate').setErrors(null);
      }
    } else if (frmCtrl === 'requiredDeliveryDate') {
      this.hhgOnlineBookShipmentForm.get(frmCtrl).setValidators([reqPackagingDateValidator(frmCtrl,
        this.hhgOnlineBookShipmentForm.get('moveDate').value, this.hhgOnlineBookShipmentForm.get('requestedPackingDate').value, eventObj)]);
      if (this.hhgOnlineBookShipmentForm.get('requestedPackingDate').value < this.hhgOnlineBookShipmentForm.get('moveDate').value) {
        this.hhgOnlineBookShipmentForm.get('moveDate').setErrors(null);
      }
    } else if (frmCtrl === 'moveDate') {
      this.hhgOnlineBookShipmentForm.get('requestedPackingDate').setErrors(null);
      this.hhgOnlineBookShipmentForm.get('requiredDeliveryDate').setErrors(null);
      this.hhgOnlineBookShipmentForm.get(frmCtrl).setValidators([Validators.required, reqPackagingDateValidator(frmCtrl,
        eventObj, this.hhgOnlineBookShipmentForm.get('requestedPackingDate').value, this.hhgOnlineBookShipmentForm.get('requiredDeliveryDate').value)]);
    }
  }

  /**
   * @description checks the status of accessorials before confirming the shipment for carriers and non-oto's
   * @param isConfirm
   */
  validateConfirm() {
    if (this.isCarrierView) {
      if (!this.accessorialTspStatus.every(x => x === 'Accepted') && (this.hhgOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value === 'Accept')) {
        this.alertService.error('You have at least one or more accessorials that are not in Accepted status. Please validate them before confirming the shipment or select a different option to confirm the shipment.');
      } else if (this.accessorialTspStatus.some(x => x === 'Qualified') && (this.hhgOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value !== 'Accept With Qualification' && this.hhgOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value !== 'Refuse')) {
        this.alertService.error('You have at least one qualified accessorial. Please select Accept with Qualification.');
      } else if (this.accessorialTspStatus.some(x => x === null) && (this.hhgOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value === 'Accept' || this.hhgOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value === 'Accept With Qualification')) {
        this.alertService.error('You have at least one or more accessorials not validated. Please validate before confirming the shipment.');
      } else if (this.accessorialTspStatus.every(x => x === 'Accepted') && (this.hhgOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value !== 'Accept' && this.hhgOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value !== 'Refuse' && this.hhgOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value !== 'Accept With Qualification')) {
        this.alertService.error('You have all accessorials in Accepted status. Please select the Accept option to confirm the shipment.');
      } else {
        this.confirmShipment();
      }
    } else {
      this.confirmShipment();
    }
  }


  /**
   * @description confirm and save shipment details
   */
  confirmShipment() {
    //do address validation
    this.loader.show();
    let alladdressExist = true;
    this.nameAndAddressService.getShipmentAddresses(this.shipmentInfo.shipmentsInfoId).pipe(takeWhile(() => this.observer$.value)).subscribe((existingAddresses: any) => {
      const addressArray: any = [];
      existingAddresses.forEach((address, i) => {
        addressArray.push(address.recordType);
      });
      this.addressValidationRecordTypes.forEach(recordType => {
        if (!addressArray.includes(recordType)) {
          alladdressExist = false;
          console.log(recordType);
          this.alertService.error('Missing address record');
        }
      });
      this.loader.hide();
    }, error => {
      this.loader.hide();
      console.log('There was an error retrieving agency details =>' + error);
      this.alertService.error('Error retrieving address details for validation');
    }, () => {
      if (alladdressExist) {
        this.modalRef = this.modalService.show(ConfirmationModalComponent);
        this.modalRef.content.question = 'By clicking “OK”, you acknowledge that you are about ' +
          'to create a binding contract with a transportation service provider (TSP). You will be held personally responsible under 31 U.S.C. ' +
          '3322 & 3333 for any improper charges or commitments resulting from your actions as a Government disbursing officer obligating ' +
          'government funds. Please contact the GSA Employee Relocation Resource Center at errc@gsa.gov for information and training. ' +
          'Click “Cancel” to return to the shipment booking form.';
        this.modalRef.content.confirmText = 'OK';
        this.modalRef.content.cancelText = 'Cancel';
        this.modalRef.content.emitData.subscribe(result => {
          if (result.obj === true) {
            this.modalRef = this.modalService.show(ConfirmationModalComponent);
            if (this.hhgOnlineBookShipmentForm.get('bookingType').value === true) {
              this.modalRef.content.question = 'Click OK to confirm booking of this shipment.  Click Cancel to return to Book Shipment.';
            } else {
              this.modalRef.content.question = 'Click OK to confirm booking of this shipment and notify the TSP.  Click Cancel to return to Book Shipment.';
            }
            this.modalRef.content.confirmText = 'OK';
            this.modalRef.content.cancelText = 'Cancel';
            this.modalRef.content.emitData.subscribe(result => {
              if (result.obj === true) {
                this.saveShipment('confirm');
              }
            });
          }
        });
      }
    });
  }

  /**
   * @description Navigates to the Address modal
   */
  enterAddressModal() {
    this.prepareShipmentData(null);
    this.onlineBookShipmentService.setShipmentsObservable(this.shipmentInfo);
    const addressPath = 'bookshipmentaddresses';
    if (this.isCarrierView) {
      const initialState = {
        modalCalledFrom: 'bookShipment',
        shipmentInfoId: this.shipmentInfo.shipmentsInfoId
      };
      this.modalRef = this.modalService.show(BillofladingAddressesComponent, {initialState, class: 'modal-lg'});
    } else {
      this.router.navigate(['/', 'bookshipmentaddresses'], {
        queryParams: {shipmentid: this.shipmentInfo.shipmentsInfoId}
      });
    }
  }

  /**
   * @description Navigates to the Accessorial modal
   */
  enterAccessorialModal() {
    this.prepareShipmentData(null);
    this.onlineBookShipmentService.setShipmentsObservable(this.shipmentInfo);
    this.router.navigate(['/', 'hhgshipmentaccessorials'], {
      queryParams: {shipmentid: this.shipmentInfo.shipmentsInfoId, bookshipmentid: this.bookshipmentid}
    });
  }

  /**
   * @description Navigates to the shipment control review screen with booking status 'Cancelled'
   */
  cancelShipment() {
    const bookingStatus = this.shipmentInfo.bookShipmentsEntity.bookingStatus;
    if (bookingStatus != BookShipmentStatus.CANCELLED) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to cancel this shipment?';
      this.modalRef.content.title = 'Shipment Cancellation';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.cancelBookShipment = true;
          this.disabled = true;
          this.saveShipment(null);
        }
      });
    } else {
      this.alertService.warn('Shipmemt is already in Cancelled status.');
    }
  }

  /**
   * @description when the accept/refuse booking drop down selection changes
   */
  acceptRefuseBookingChanged(value) {
    if (value == 'Accept With Qualification' || value == 'Refuse') {
      this.acceptRejectionWithReason = true;
      if (value == 'Accept With Qualification') {
        this.isAcceptedWithQualificationByCarrier = true;
      } else {
        this.isAcceptedWithQualificationByCarrier = false;
      }
    } else if (value == 'Accept') {
      this.acceptRejectionWithReason = false;
    }
  }

  /**
   * @description when the accept reasons drop down selection changes
   */
  acceptedWithQualificationReasonChanged(value) {
    this.acceptSpecifyReason = true;
    if (value === this.bookShipmentInfo.refusalOrQualificationReason) {
      this.hhgOnlineBookShipmentForm.controls['carrierAcceptReason'].setValue(this.bookShipmentInfo.refusalOrQualificationRemarks);
    } else {
      this.hhgOnlineBookShipmentForm.controls['carrierAcceptReason'].setValue('');
    }
  }

  /**
   * @description Navigates to Audit Trial
   */
  viewBookingAuditTrial() {
    this.router.navigate(['/', 'shipmentaudit'], {
      queryParams:
        {shipmentId: this.shipmentInfo.shipmentsInfoId, bookshipmentid: this.bookshipmentid}
    });
  }

  /**
   * @description Navigates to Bill of lading
   */
  viewBillOfLading() {
    this.getSelectedBookingTypes();
    this.selectedShipmentType = this.getSelectedBookingTypes().join(' & ');
    this.router.navigate(['/', 'hhgbilloflading'], {
      queryParams:
        {
          shipmentId: this.shipmentInfo.shipmentsInfoId,
          bookshipmentid: this.bookshipmentid,
          selectedShipmentType: this.selectedShipmentType
        }
    });
  }

  /**
   * @description when the reject reasons drop down selection changes
   */
  refusedReasonChanged(value) {
    this.rejectSpecifyReason = true;
    if (value === this.bookShipmentInfo.refusalOrQualificationReason) {
      this.hhgOnlineBookShipmentForm.controls['carrierRefuseReason'].setValue(this.bookShipmentInfo.refusalOrQualificationRemarks);
    } else {
      this.hhgOnlineBookShipmentForm.controls['carrierRefuseReason'].setValue('');
    }
  }

  onGetInitData(){
    return JSON.stringify(this.hhgOnlineBookShipmentForm.getRawValue());
  }

  onComparedFormChanges(){
    return _.isEqual(this.initFormData, this.finalFormData);
  }

  initValueForBookedStatus(){
      this.initFormData = this.onGetInitData();
      if (this.isCarrierView) {
        this.disabledConfirm = false;
      } else {
        this.onValidationChangesOfForm();
      }
      
    //  this.disabledConfirm = true;
  }
  
  onValidationChangesOfForm(){
    this.hhgOnlineBookShipmentForm.valueChanges.subscribe(x => {
         this.finalFormData = this.onGetInitData();
         this.disabledConfirm = (!this.onComparedFormChanges()) ? false: true;
    });
    
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
    console.log('hhg online book shipment component destroy');
  }

}
